export default {
    id: 'ExportTableInfo',
    code: 'CN',
    text: {
      'Age': '年龄',
      'Gender': '性别',
      'DOB': '生日',
      'Phone': '联系电话',
      'Email': '联系邮箱',
      'Address': '现居地址',
      'Created On': '注册时间',
      'Nickname': '学员昵称',
      'Name': '姓名',
      'Remark': '备注',
      'Primary Guardian Name': '家长1姓名',
      'Primary Guardian Phone': '家长1电话',
      'Primary Guardian Email': '家长1邮箱',
      'Primary Guardian Relationship': '家长1关系',      
      'Secondary Guardian Name': '家长2姓名',
      'Secondary Guardian Phone': '家长2电话',
      'Secondary Guardian Email': '家长2邮箱',  
      'Secondary Guardian Relationship': '家长2关系',
      'Male': '男生',
      'Female': '女生',
      'Other': '其他',
      'N/A': '未提供',
      'Download': '导出',
      'Redownload': '重新导出',
      'Download Excel': '导出 Excel',
      'Export Student List': '导出学员列表',
      'Export Teacher Attendance': '导出老师签到记录',
      'Export Student Attendance': '导出学生签到记录',
      'Export Transaction Records': '导出交易记录',
      'Loading...': '正在载入...',
      'Student Number': '学号',
      'Download Successfully!' :'成功导出!',
      'Student Status': '学员状态',
      'Current': '当期学员',
      'Past': '历史学员',
      'Absent (without notice)': '旷课',
      'Late': '迟到',
      'Attended': '出勤',
      'Absent (with excuse)': '请假',
      'Unattended': '未出勤',
      'Make Up': '补签',
      'Unchecked': '无记录',
      'Current Student List': '在读学生列表',
      'Past Student List': '历史学生列表'
    }
  }
  


// WEBPACK FOOTER //
// ./src/template/Modals/Export/locale.js